export default {"src":"/_next/static/media/jesenik.de4138da.svg","height":98,"width":468,"blurWidth":0,"blurHeight":0};